import Vue from 'vue';

const SET_OPEN_EXCHANGES = (state, exchanges) => {
  state.openExchanges = exchanges;
};

const SET_EXCHANGES = (state, exchanges) => {
  Vue.set(state, 'exchanges', [...exchanges]);
};

const SET_EXCHANGE_TYPES = (state, exchangeTypes) => {
  state.exchangeTypes = exchangeTypes;
};

export default {
  SET_OPEN_EXCHANGES,
  SET_EXCHANGES,
  SET_EXCHANGE_TYPES,
};
